<section class="deal-container">
    <div class="deal-info">
        <div *ngIf="deal.statusId !== 3" class="documents-section">
            <h3>Documents To Sign</h3>

            <div class="documents-flex">
                <p *ngIf="docList.length <= 0">No Documents To Sign</p>
                <!-- internalDocumentTypeId 24 is BuyerEsignConsent and 33 is CoBuyerFinalSignatureDocument -->
                <!-- internalDocumentTypeId 25 is BuyerFinalSignatureDocument and 34 is CoBuyerFinalSignatureDocument -->
                <div
                    *ngFor="let document of docList"
                    class="document"
                    [class.disabled]="isDocumentDisabled(document)"
                    [class.disable-cursor]="isDocumentCursorDisabled(document)"
                >
                    <div class="document-container" (click)="routeTo(document)">
                        <div class="document-name">
                            <span class="material-icons file-icon">insert_drive_file</span>
                            <p>
                                {{ document.displayName }}
                            </p>
                        </div>
                        <div class="info-icon">
                            <mat-icon [matTooltip]="document.preamble">info_flat</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="documents-section completed-documents">
            <div class="completed">
                <h3>Completed Documents</h3>
                <div class="align-btn">
                    <button
                        mat-button
                        [ngClass]="hasCustomerDocsForDownload() ? 'download' : 'disabled'"
                        [disabled]="!hasCustomerDocsForDownload()"
                        (click)="downloadDocuments()"
                    >
                        Download Documents
                    </button>
                </div>
            </div>
            <div class="documents-flex">
                <p *ngIf="dealDocs.complete.length <= 0">No Documents Completed</p>
                <div *ngFor="let document of dealDocs.complete" class="document">
                    <div class="document-container" (click)="routeTo(document, 'view')">
                        <div class="document-name">
                            <span class="material-icons complete">check_circle</span>
                            <p>
                                {{ document.displayName }}
                            </p>
                        </div>
                        <div class="info-icon">
                            <mat-icon [matTooltip]="document.preamble">info_flat</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vehicle-info">
        <div class="refresh-section">
            <button (click)="reloadPage()" mat-button class="refresh"><mat-icon>refresh</mat-icon> Refresh Page</button>
        </div>
        <buyer-vehicle-info-header [vehicle]="vehicle" [deal]="deal"> </buyer-vehicle-info-header>
    </div>
</section>
